import type { FormInstance } from 'antd';
import { Form as AntForm, FormProps as AntFormProps } from 'antd';
import React, { ReactNode } from 'react';
import {
  Controller,
  FieldValues,
  FormProvider,
  SubmitHandler,
  UseFormReturn,
} from 'react-hook-form';

interface FormProps<T extends FieldValues>
  extends AntFormProps,
    UseFormReturn<T> {
  children: ReactNode;
  layout?: 'horizontal' | 'vertical' | 'inline';
  className?: string;
  onSubmit: SubmitHandler<T>;
}

const Form = React.forwardRef<FormInstance, FormProps<any>>(
  ({ children, className, layout, onSubmit, ...methods }, ref) => {
    return (
      <FormProvider {...methods}>
        <AntForm
          ref={ref}
          layout={layout}
          className={className}
          onFinish={methods.handleSubmit(onSubmit)}
        >
          {children}
        </AntForm>
      </FormProvider>
    );
  },
);

Form.displayName = 'Form';

export { Controller, Form };
export default Form;
